// SPDX-FileCopyrightText: Copyright (C) 2026 provide.io llc
// SPDX-License-Identifier: Apache-2.0
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { routes } from "./routes";
import "./styles/globals.css";

declare const __VERSION__: string;
// reference __VERSION__ to retain it in the build (used by future TopBar)
void __VERSION__;

const router = createBrowserRouter(routes);
const root = document.getElementById("root");
if (!root) throw new Error("root not found");
createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
